import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Entiende el Cortocircuito',
  desc: 'Identifica en segundos cuándo el cerebro de tu hijo se ha “desconectado” de la lógica.'
}, {
  num: '2',
  title: 'Lanza el Cortafuegos',
  desc: 'Aplica los guiones breves para detener la pelea antes de que escale.'
}, {
  num: '3',
  title: 'Reconstruye el Canal',
  desc: 'Usa las técnicas de tregua para que tu hijo vuelva a verte como un aliado y no como el enemigo.'
}];
export function MethodSection() {
  return <section className="py-24 bg-brand-cream px-4" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-115">
          <h2 className="text-3xl md:text-4xl text-brand-navy font-bold mb-4" data-id="element-116">
            Cómo funciona el método
          </h2>
          <div className="w-24 h-1 bg-brand-orange mx-auto rounded-full" data-id="element-117"></div>
        </motion.div>

        <div className="space-y-8 mb-24 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-brand-orange/20 before:via-brand-orange/50 before:to-brand-orange/20" data-id="element-118">
          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: idx * 0.2
        }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-119">
              {/* Icon / Number */}
              <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-brand-cream bg-brand-orange text-white font-bold text-xl shadow-lg shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-120">
                {step.num}
              </div>

              {/* Content Card */}
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-2xl shadow-soft border border-brand-cream-light" data-id="element-121">
                <h3 className="text-xl font-bold text-brand-navy mb-2" data-id="element-122">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-123">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>

        {/* 7 Days Result */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-navy text-white p-8 md:p-12 rounded-3xl text-center shadow-xl relative overflow-hidden" data-id="element-124">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-orange via-yellow-400 to-brand-orange" data-id="element-125"></div>
          <h3 className="text-3xl font-serif font-bold mb-6 text-brand-cream" data-id="element-126">
            ¿Qué cambia en 7 días?
          </h3>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-127">
            No tendrás un hijo perfecto, pero tendrás una casa en silencio. Al
            aplicar el Cortafuegos Verbal, la resistencia de tu hijo disminuye
            porque ya no tiene contra qué chocar. Verás cómo los portazos
            disminuyen y, por primera vez en meses, podrán compartir una cena
            sin terminar en una guerra mundial.
          </p>
        </motion.div>
      </div>
    </section>;
}